import { Directive, ElementRef } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

@Directive({
    selector: '[appNgSelectOpen]',
    standalone: false
})
export class NgSelectOpenDirective {

  constructor(private el: ElementRef, private ngSelect: NgSelectComponent) { }

  ngOnInit() {
    this.el.nativeElement.addEventListener('openNgSelect', () => {
      this.ngSelect.focus();
      this.ngSelect.open();
    });
  }
}